import { render, staticRenderFns } from "./InformationDetail.vue?vue&type=template&id=6a95af5c&scoped=true"
import script from "./InformationDetail.vue?vue&type=script&lang=js"
export * from "./InformationDetail.vue?vue&type=script&lang=js"
import style0 from "./InformationDetail.vue?vue&type=style&index=0&id=6a95af5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a95af5c",
  null
  
)

export default component.exports